import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical, image }) => {
  const siteTitle = "Dr. Suresh Pet Care Hospital";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const defaultDescription = "Dr. Suresh Pet Care Hospital offers elite veterinary surgery, advanced diagnostics, and compassionate pet care in Vanasthalipuram, Hyderabad.";
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || "dog clinic Vanasthalipuram, veterinary clinic Hyderabad, Dr. T Suresh Babu, best pet hospital Hyderabad";
  const siteUrl = "https://drsureshpetcarehospital.in";
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const ogImage = image || `${siteUrl}/images/logo-pet.png`;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
